import { useTranslation } from "react-i18next";

import { RootStateBase } from '../../../store/baseStore';
import * as S from './styles'
import { useTheme } from '../../../utils/context/themeContext';
import { TailSpin } from 'react-loader-spinner';
import { LoadingMessage } from "../styles";
import { connectState, PropsFromRedux } from 'base/src/utils/reduxUtil';

const connector = connectState(
  (state: RootStateBase) => ({
    loading: state.BaseReducer.Loading,
  })
);

export interface LoadingProps extends PropsFromRedux<typeof connector> {
  stateNames: string[];
}

function Loading (props: LoadingProps) {
    const { t } = useTranslation();
    const { theme } = useTheme();

    const loading = props.loading.find((e) => props.stateNames.includes(e.Name));


    return (
        props.loading.find((e) => props.stateNames.includes(e.Name)) &&

        <S.Loading className='fullCenter'>
            {loading != null ? (
                <>
                    <TailSpin
                        visible={true}
                        height="40"
                        width="40"
                        color={theme.colors.primary}
                        ariaLabel="tail-spin-loading"
                        radius="0"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                    <LoadingMessage>{loading.Message}</LoadingMessage>
                </>
            ) : (t("Carregando"))}
        </S.Loading>
    )
}

const ConnectedLoading = connector(Loading);
export default ConnectedLoading;
